import React, { useState, useEffect, useRef } from 'react';
import '../../css/partnersDetails.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaArrowLeftLong } from "react-icons/fa6";
import { useMobileMediaQuery, useTabletMediaQuery } from '../../utils';
import { GoDotFill } from "react-icons/go";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { MdOutlinePhoneInTalk } from "react-icons/md";
import { MdOutlineAlternateEmail } from "react-icons/md";
import { IoGlobeOutline } from "react-icons/io5";
import { FaArrowRightLong } from "react-icons/fa6";
import ImgArrowRight from '../../assets/svg/iconArrowPartnersDetails.svg';
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import GoogleMap from '../../components/GoogleMap';
import Heading from '../../components/Heading';
import GifAnim from '../../components/GifAnim';
import IconAddCard from '../../assets/svg/iconAddCardPartnersDetails.svg';
import IconGetPercentage from '../../assets/svg/iconGetPercentagePartnersDetails.svg';
import IconSpendBalance from '../../assets/svg/iconSpendBalancePartnersDetails.svg';
import IconCheckHistory from '../../assets/svg/iconCheckHistoryPartnersDetails.svg';
import { useDispatch, useSelector } from 'react-redux';
import { setSessionId, setCookieId } from '../../features/onboardingData/onboardingUserData';
import useCodes from '../../hooks/useCodes';
import { errorHandling } from '../../utils';
import Badge from '@mui/material/Badge';
import PlaceholderLoading from 'react-placeholder-loading';
import { RiMapPinLine } from "react-icons/ri";
import CustomBreadcrumbs from '../../components/Breadcrumbs/CustomBreadcrumbs';
import SuspendedWalletAlert from '../../components/SuspendedWalletAlert';

function  PartnersDetails() {

    const isSessionId = useSelector((state) => state.onboardingUserData.isSessionId);
    const isCookieId = useSelector((state) => state.onboardingUserData.isCookieId);
    const isStatusCarteira = useSelector((state) => state.onboardingUserData.isStatusCarteira);
    const [isLoading, setIsLoading] = useState(true);
    const [imgLogo, setImgLogo] = useState('');
    const navigate = useNavigate();
    const isMobile = useMobileMediaQuery();
    const isTablet = useTabletMediaQuery();
    const [swiperIndexTwo, setSwiperIndexTwo] = useState(0);
    const [swiperInstanceTwo, setSwiperInstanceTwo] = useState(null);
    const [swiperIndexOne, setSwiperIndexOne] = useState(0);
    const [swiperInstanceOne, setSwiperInstanceOne] = useState(null);
    const location = useLocation();
    const categoryItem = location.state?.item || ''; 
    const [isPressedItem, setIsPressedItem] = useState(false)
    const [showAlertInfo, setShowAlertInfo] = useState(false);
    const [email, setEmail] = useState('');
    const [telefone, setTelefone] = useState('');
    const [webSite, setWebSite] = useState('');
    const [listaLojasAderentes, setListaLojasAderentes] = useState([]);
    const [cards, setCards] = useState([]);
    const { getIconType } = useCodes();
    const [isStoreOnline, setStoreOnline] = useState('');
    const [isStorePhysical, setStorePhysical] = useState('');
    const [storeType, setStoreType] = useState('');
    const alertRef = useRef(null);
    
    const hadleBtnBoxGoMovements = () => {
        navigate('/movimentos');
    };

    const hadleBtnBoxGoPartnersList = () => {
        navigate('/ganhar-saldo/parceiros/catalogo-de-parceiros');
    };

    const hadleBtnBoxGoAddCard = () => {
        navigate('/configuracoes/associar-cartao/tipo-de-associacao');
    };

    const hadleBtnBoxGoMarketplace = () => {
        window.open('https://marketplace.medis.pt/', '_blank');
    };

    useEffect(() => {
        switch(isStoreOnline !== '' && isStorePhysical !== '') {
            case (isStoreOnline  === 'N' && isStorePhysical === 'S'):
                setStoreType('Loja física');
                break;
            case (isStoreOnline  === 'S' && isStorePhysical === 'N'):
                setStoreType('Loja online');
                break;
            case (isStoreOnline  === 'S' && isStorePhysical === 'S'):
                setStoreType('Loja física e loja online');
                break;
            default:
                setStoreType('');
        }        
    }, [isStoreOnline, isStorePhysical]);

    const getInfoParceiros = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_DEV_URL}/getInfoParceiros/fetchGetInfoParceiros`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': 'PT-PT',
                    'CookieId': `${isCookieId}`,
                    'SessionId': `${isSessionId}`,
                    'idComerciante': `${categoryItem?.idComerciante}`,
                    'idEstabelecimento': `${categoryItem?.idEstabelecimento}`,
                },
            });
            if (response.ok === false) {
                errorHandling(response.status);
                return;
            }
            const result = await response.json();
            if (result.error.erroMsg === 'Success') {
                setImgLogo(result.urlImagem);
                setEmail(result.email);
                setTelefone(result.telefone);
                setWebSite(result.website);
                setListaLojasAderentes(result.listaLojasAderentes);
                setCards(result.cards);
                setStoreOnline(result.iOnline);
                setStorePhysical(result.iFisica);
            }
        } catch (error) {
            if (!navigator.onLine) {
                errorHandling('NoInternet');
            } else if (error instanceof TypeError && error.message === "Failed to fetch") {
                errorHandling('CORS');
            } else {
                errorHandling();
            }
        }
    }

    useEffect(() => {
        categoryItem !== '' && getInfoParceiros();
    }, [categoryItem]);

    useEffect(() => {
        const delay = setTimeout(() => {
        setIsLoading(false); 
        }, 1000); 

        return () => clearTimeout(delay); 
    }, []);

    const handleShowInfo = (item) => {
        setIsPressedItem(item)
        setShowAlertInfo(!showAlertInfo)
    };

    const handleClickCloseInfoAlert = () => {
        setShowAlertInfo(!showAlertInfo)
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (alertRef.current && !alertRef.current.contains(event.target)) {
                handleClickCloseInfoAlert();
            }
        };

        if (showAlertInfo) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showAlertInfo, handleClickCloseInfoAlert]);

    const nextImageTwo = () => {
        if (swiperInstanceTwo !== null) {
            swiperInstanceTwo.slideNext();
        }
    };

    const prevImageTwo = () => {
        if (swiperInstanceTwo !== null) {
            swiperInstanceTwo.slidePrev();
        }
    };

    const handleSwiperSlideChangeTwo = (swiperTwo) => {
        setSwiperIndexTwo(swiperTwo.activeIndex);
    };

    const nextImageOne = () => {
        if (swiperInstanceOne !== null) {
            swiperInstanceOne.slideNext();
        }
    };

    const prevImageOne = () => {
        if (swiperInstanceOne !== null) {
            swiperInstanceOne.slidePrev();
        }
    };

    const handleSwiperSlideChangeOne = (swiperOne) => {
        setSwiperIndexOne(swiperOne.activeIndex);
    };

    const handleEmailClick = () => {
        const emailAddress = email;
        const mailtoLink = `mailto:${emailAddress}`;
    
        window.location.href = mailtoLink;
    }

    const renderIconByItem = (categoryItem) => {
        const iconType =  getIconType(categoryItem.categoria);
        return iconType;
    };

    const handkeChangeMaxLength = (text, maxLength) => {
        if (text?.length > maxLength) {
            return text.slice(0, maxLength) + '...';
        }
        return text;
    };

    const handleBtnGoToContacts = () => {
        navigate('/configuracoes#contactMainContainer');
    };

    return (  
        <>
        <Header/> 
        { isLoading ? 
            <GifAnim />
        :
        <>
        {/* Start fist div componet with title / header */}
        <div className={ isTablet ? "mainViewContainerPartnersDetails" : ( isMobile ? 'mainViewContainerPartnersDetailsTablet' : 'mainViewContainerPartnersDetailsMobile')}>
            <div className={ isTablet ? 'firstTxtViewContainerPartnersDetails' : ( isMobile ? 'firstTxtViewContainerPartnersDetailsTablet' : 'firstTxtViewContainerPartnersDetailsMobile') }>
                <div style={ isTablet ? { width: '100%', height: '100%', marginBottom: '48px', marginTop: '-48px' } :  ( isMobile ? { width: '100%', height: '100%', paddingInline: '40px' } : { width: '100%', height: '100%', paddingInline: '16px' })}>
                    { (isStatusCarteira ===  '2')  &&
                        <SuspendedWalletAlert onPress={handleBtnGoToContacts} />
                    }
                </div> 
                <div className='mainHeadingViewContainerEarnBalance'> 
                    <CustomBreadcrumbs hasPadding hasEarnBalance hasPartnerCatalog nomeparceiro={categoryItem.nomeparceiro} />
                    <Heading hasPadding hasBtnBack={false}/>
                </div>

                {/* End fist div componet with title / header */}

                {/* Start second div componet with partner details */}
                <div className={ isTablet ? 'secondMainContainerWithInfoPartnersDetails' : ( isMobile ? 'secondMainContainerWithInfoPartnersDetailsTablet' : 'secondMainContainerWithInfoPartnersDetailsMobile') }>
                    <div className={ isTablet ? 'mainRowViewContainerWithInfoPartnersDetails' : ( isMobile ? 'mainRowViewContainerWithInfoPartnersDetailsTablet' : 'mainRowViewContainerWithInfoPartnersDetailsMobile')}>
                        <img src={imgLogo} alt="imagem" className="mainIconPartnerLogoSvgPartnersDetails" />
                        <div className='columnViewContainerWithInfoPartnersDetails'>
                            {categoryItem?.nomeparceiro?.length > 15 ?
                                <>
                                    <div className='txtPartnerLogoPartnersDetails'>{handkeChangeMaxLength(categoryItem.nomeparceiro, 15)}</div>

                                    <div className='alertHoverInfoMainViewPartnersDetails'>
                                        <div className='mainViewAlerSmModalPartnersDetails'>
                                            <div className='txtAlerSmModalPartnersDetails'>{categoryItem.nomeparceiro}</div>
                                        </div>
                                    </div>
                                </>
                            : 
                                <div className='txtPartnerLogoPartnersDetails'>{categoryItem.nomeparceiro}</div> 
                            }
                            <div className='rowViewContainerWithInfoPartnersDetails'>
                                <img src={renderIconByItem(categoryItem)?.img} alt="imagem" className="iconPartnerCategorySvgPartnersDetails" />
                                <div className='txtPartnerCategoryPartnersDetails'>{categoryItem.categoria}</div>
                            </div>
                        </div>
                    </div>
                    <div className={isTablet ? 'secondSliderAdsContainerPartnersDetails' : ( isMobile ? 'secondSliderAdsContainerPartnersDetailsTablet' : 'secondSliderAdsContainerPartnersDetailsMobile')}>
                        <Swiper
                            onSlideChange={(swiperTwo) => handleSwiperSlideChangeTwo(swiperTwo)}
                            onSwiper={(swiperTwo) => setSwiperInstanceTwo(swiperTwo)}
                            slidesPerView={isTablet ? (cards?.length > 2 ? 2.05 : cards?.length > 1 ? 2 : 1) : 1}
                            spaceBetween={32}
                            // pagination={{
                            //     clickable: true,
                            //   }}
                            modules={[Pagination]}
                            className={isTablet ? (cards?.length > 1 ? "mySwiperPartnersDetails" : 'singleCardsViewContainerPartnersDetails' ) : ( isMobile ? "mySwiperPartnersDetailsTablet" : "mySwiperPartnersDetailsMobile")}
                        >
                            {cards.map((item, index) => (
                                <SwiperSlide key={index}>
                                    <div className={isTablet ? 'secondSliderAdsOfertaPartnersDetails' : 'secondSliderAdsOfertaPartnersDetailsMobile'}>
                                        <div className='txtTitleColumnViewAdsOfferPartnersDetails'>
                                            <div className='txtTitleSmallColumnViewAdsOfferPartnersDetails'>
                                                <div className='txtTitleBoldAdsOfferPartnersDetails'><b>{item.titulo}</b></div>
                                                <div className='txtTitleAdsOfferPartnersDetails'>{item.subtitulo}</div>
                                            </div>
                                            <div className='txtTitleAdsOfferPartnersDetails'>{item.texto}</div>      
                                        </div>
                                        <div className='txtTitleRowViewAdsOfferPartnersDetails'>
                                            <div className='txtCashbackAdsOfferPartnersDetails'>
                                                <div className='iconTitleAdsOfferPartnersDetails'><GoDotFill /></div>
                                                <div className='txtTitleAdsOfferPartnersDetails'>{item.categoria}</div>
                                                <button className='infoHeaderIonBtnAdsOfferPartnersDetails'  type='button' onClick={ () => handleShowInfo(item)} >
                                                    <IoMdInformationCircleOutline className='infoHeaderIcondsOfferPartnersDetails' />
                                                </button>
                                                { (isPressedItem === item && showAlertInfo) &&
                                                        <div className='alertInfoMainViewPartnersDetails' ref={alertRef}  onClick={handleClickCloseInfoAlert}>
                                                            <div className='mainViewAlerSmModalPartnersDetails '>
                                                                {/* <div className='txtTitleAlerSmModalPartnersDetails '>Tem dúvidas?</div> */}
                                                                <div className='txtAlerSmModalPartnersDetails '>{item.infoCard}</div>
                                                            </div>
                                                        </div>
                                                    }
                                            </div>
                                            <div className='txtCashbackAmountAdsOfferPartnersDetails'>
                                                <div className='txtTitleBoldAdsOfferPartnersDetails'>
                                                    {item.valor?.includes('%') 
                                                        ? item.valor  // Display as is if it contains '%'
                                                        : `${item.valor?.replace('.', ',')}€`  // Replace '.' with ',' and add '€'
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        { (isTablet && cards?.length > 2)  ? 
                            <div className={isTablet ? 'thirdSubMainContainerCircleNavSeePartners' : 'thirdSubMainContainerSeePartnersMobile'}>
                                <button className='iconArrowLeftViewContainerCircleNavSeePartners' onClick={prevImageTwo} disabled={swiperIndexTwo == 0}>
                                    <FaArrowLeftLong className='iconArrowCircleNavSeePartners' />
                                </button>

                                <div className='cirlceSelectedNavSeePartners'>
                                    <div className='circleMainvViewNavSeePartners'>
                                        {cards?.slice(0, -1).map((item, index) => (
                                            <div key={index} className='circleContainerNavSeePartners'>
                                                <div className={swiperIndexTwo === index ? 'circleSelectedViewNavSeePartners' : 'circleViewNavSeePartners'} />
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <button className='iconArrowRightViewContainerCircleNavSeePartners' onClick={nextImageTwo} disabled={swiperIndexTwo >= cards?.length - 2}>
                                    <FaArrowRightLong className='iconArrowCircleNavSeePartners' />
                                </button>
                            </div>
                            : (!isTablet && cards?.length > 1)  &&
                            <div className={isTablet ? 'thirdSubMainContainerCircleNavSeePartners' : 'thirdSubMainContainerSeePartnersMobile'}>
                                <button className='iconArrowLeftViewContainerCircleNavSeePartners' onClick={prevImageTwo} disabled={swiperIndexTwo == 0}>
                                    <FaArrowLeftLong className='iconArrowCircleNavSeePartners' />
                                </button>

                                <div className='cirlceSelectedNavSeePartners'>
                                    <div className='circleMainvViewNavSeePartners'>
                                        {cards.map((item, index) => (
                                            <div key={index} className='circleContainerNavSeePartners'>
                                                <div className={swiperIndexTwo === index ? 'circleSelectedViewNavSeePartners' : 'circleViewNavSeePartners'} />
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <button className='iconArrowRightViewContainerCircleNavSeePartners' onClick={nextImageTwo} disabled={swiperIndexTwo >= cards?.length - 1}>
                                    <FaArrowRightLong className='iconArrowCircleNavSeePartners' />
                                </button>
                            </div>
                        }
                    </div>
                </div>
                
                {/* End second div componet with partner details */}

                {/* Start tirhd div componet with partner contact info */}
                { isMobile ? (
                    <div className={ isTablet ? 'secondMainContainerWithhPartnerContactDataPartnersDetails' : 'secondMainContainerWithhPartnerContactDataPartnersDetailsMobile' }>
                        <div className='secondSmallContainerWithhPartnerContactDataPartnersDetails'>
                            <div className='txtPartnerContactInfoBoldPartnersDetails' style={{ marginRight: isTablet ? '16px' : '0px' }}>Contactos</div>
                            <div className='columnViewContainerWithInfoPartnersDetails'>
                                { telefone?.length > 0 &&
                                    <div className='rowViewContainerWithPartnerContactDataPartnersDetails'>
                                        <div className='iconPartnerContactDataPartnersDetails'><MdOutlinePhoneInTalk /></div>
                                        <div className='txtPartnerContactDataPartnersDetails'>{telefone}</div>
                                    </div>
                                }
                                { email?.length > 0 &&
                                    <div className='rowViewContainerWithPartnerContactDataPartnersDetails'>
                                        <div className='iconPartnerContactDataPartnersDetails'><MdOutlineAlternateEmail /></div>
                                        <div className='txtPartnerContactDataPartnersDetails' style={{ cursor: 'pointer' }} onClick={handleEmailClick}>{email}</div>
                                    </div>
                               }
                            </div>
                            { webSite?.length > 0 &&
                                <div className='rowViewContainerWithPartnerContactDataPartnersDetails'>
                                    <div className='iconPartnerContactDataPartnersDetails'><IoGlobeOutline /></div>
                                    <a  href={webSite} target="_blank" rel='noopener noreferrer'>
                                        <div className='txtPartnerContactDataPartnersDetails'>{webSite}</div>
                                    </a> 
                                </div>
                            }
                        </div>

                        <div className={ isTablet ? 'secondSmallContainerWithhPartnerContactDataBorderPartnersDetails' : 'secondSmallContainerWithhPartnerContactDataBorderPartnersDetailsMobile'}>
                            <div className='txtPartnerContactInfoBoldPartnersDetails' style={{ marginRight: '16px' }}>Compras</div>
                            <div className='txtPartnerContactInfoBlakPartnersDetails'>{storeType}</div>
                        </div>
                    </div>
                ) : (
                <div className='secondMainContainerWithhPartnerContactViewDataPartnersDetailsMobile'>
                        <div className='secondSmallContainerWithhPartnerContactDataPartnersDetailsMobile'>
                            <div className='txtPartnerContactInfoBoldPartnersDetails'>Contactos</div>
                            <div className='columnViewContainerWithInfoPartnersDetails'>
                                { telefone?.length > 0 &&
                                    <div className='rowViewContainerWithPartnerContactDataPartnersDetails'>
                                        <div className='iconPartnerContactDataPartnersDetails'><MdOutlinePhoneInTalk /></div>
                                        <div className='txtPartnerContactDataPartnersDetails'>{telefone}</div>
                                    </div>
                                }
                                { email?.length > 0 &&
                                    <div className='rowViewContainerWithPartnerContactDataPartnersDetails'>
                                        <div className='iconPartnerContactDataPartnersDetails'><MdOutlineAlternateEmail /></div>
                                        <div className='txtPartnerContactDataPartnersDetails' style={{ cursor: 'pointer' }} onClick={handleEmailClick}>{email}</div>
                                    </div>
                               }
                            </div>
                            { webSite?.length > 0 &&
                                <div className='rowViewContainerWithPartnerContactDataPartnersDetails'>
                                    <div className='iconPartnerContactDataPartnersDetails'><IoGlobeOutline /></div>
                                    <a  href={webSite} target="_blank" rel='noopener noreferrer'>
                                        <div className='txtPartnerContactDataPartnersDetails'>{webSite}</div>
                                    </a> 
                                </div>
                            }
                        </div>

                        <div className='secondSmallContainerWithhPartnerContactDataPartnersDetailsMobile'>
                            <div className='txtPartnerContactInfoBoldPartnersDetails'>Compras</div>
                            <div className='txtPartnerContactInfoBlakPartnersDetails'>{storeType}</div>
                        </div>
                    </div>
                )}
                {/* End tirhd div componet with partner contact info */}

                {/* Start firth div componet with partner google maps */}

                { storeType !== 'Loja online' ? 
                (
                    
                    <div className={ isTablet ? 'mainGoogleMapViewContainerPartnersDetails' : 'mainGoogleMapViewContainerPartnersDetailsMobile'}>
                        <GoogleMap listaLojasAderentes={listaLojasAderentes} nomeparceiro={categoryItem.nomeparceiro} imgLogo={imgLogo}/>
                    </div>
                ) : (
                    <div className={ isTablet ? 'mainGoogleMapGridWithOutInfoViewContainerNoMapPartnersDetails' : ( isMobile ? 'mainGoogleMapGridWithOutInfoViewContainerNoMapPartnersDetailsTablet' : 'mainGoogleMapGridWithOutInfoViewContainerNoMapPartnersDetailsMobile' )}>
                        { isLoading ? <PlaceholderLoading shape="rect" width={150} height={20}/> : (
                        <div className='txtViewTitleListItemsGoogleMapViewContainerPartnersDetails'>
                            <Badge badgeContent={listaLojasAderentes?.length} style={{color: '#fff'}}>
                                <div className='txtTitleListItemsGoogleMapViewContainerPartnersDetails'>Lojas aderentes</div>
                            </Badge>
                        </div>
                        )}
                        { listaLojasAderentes.map((item, index) =>(
                        <div key={index} className={ isTablet ? 'columnGridViewGoogleMapViewContainerPartnersDetails' : ( isMobile ? 'columnGridViewGoogleMapViewContainerPartnersDetails' : 'columnGridViewGoogleMapViewContainerPartnersDetailsMobile' )}>
                            { isLoading ? <PlaceholderLoading shape="rect" width={300} height={125}/> : (
                            <>
                            <div className='rowGridViewGoogleMapViewContainerPartnersDetails'>
                                {/* <div className='txtTitleStoreNameGoogleMapViewContainerPartnersDetails'>{nomeparceiro} <br/> {item.nome}</div> */}
                                <div className='txtTitleStoreNameGoogleMapViewContainerPartnersDetails'>{item.nome}</div>
                                <img src={imgLogo} alt="imagem" className="iconPartnerLogoSvgPartnersDetails" />
                            </div>
                            <div className='columnGridSubLineViewGoogleMapViewContainerPartnersDetails'>
                                <div className='txtTitleStoreNameGoogleMapViewContainerPartnersDetails'>Endereço</div>
                                <div className='txtStoreNameGoogleMapViewContainerPartnersDetails'><RiMapPinLine /> {item.morada}</div>
                                <div className='txtStoreNameGoogleMapViewContainerPartnersDetails'>{item.codigoPostal}</div>
                            </div>
                            </>
                            )}
                        </div>
                        ))}
                    </div>
                        
                )}

                {/* End firth div componet with partner google maps */}

                {/* Start bottom div componet with info steps */}
                <div className={ isTablet ? 'mainBottomViewContainerPartnersDetails' : ( isMobile ? 'mainBottomViewContainerPartnersDetailsTablet' : 'mainBottomViewContainerPartnersDetailsMobile')}>
                    <div className={ isTablet ? 'titileViewForBottomViewContainerPartnersDetails' : (isMobile ? 'titileViewForBottomViewContainerPartnersDetailsTablet' : 'titileViewForBottomViewContainerPartnersDetailsMobile')}>
                        <div className={ isTablet ? 'textTitleBoldPartnersDetailsWithSaldo' : 'textTitleRegularPartnersDetailsWithSaldoMobile'}>Como funciona?</div>
                        <div className='txtPartnerContactInfoBlakPartnersDetails'>Faça compras e acumule dinheiro. <br/>Receba de volta uma percentagem do valor que gastou.</div>
                    </div>

                    <div className={isTablet ? 'secondSliderAdsContainerPartnersDetails' : ( isMobile ? 'secondSliderAdsContainerPartnersDetailsTablet' : 'secondSliderAdsContainerPartnersDetailsMobile')}>
                        <Swiper
                            onSlideChange={(swiperOne) => handleSwiperSlideChangeOne(swiperOne)}
                            onSwiper={(swiperOne) => setSwiperInstanceOne(swiperOne)}
                            slidesPerView={ isTablet ? 3 : 1}
                            spaceBetween={32}
                            // pagination={{
                            //     clickable: true,
                            //   }}
                            modules={[Pagination]}
                            className={isTablet ? "mySwiperBoxViewContainerPartnersDetails" : ( isMobile ? "mySwiperBoxViewContainerPartnersDetailsTablet" : "mySwiperBoxViewContainerPartnersDetailsMobile")}
                        >
                            <SwiperSlide>
                                <div onClick={hadleBtnBoxGoAddCard} className={ isTablet ? 'boxViewContainerBottomViewContainerPartnersDetails' : ( isMobile ? 'boxViewContainerBottomViewContainerPartnersDetailsTablet' : 'boxViewContainerBottomViewContainerPartnersDetailsMobile')}>
                                    <img src={IconAddCard} alt="imagem" className="iconPartnerLogoSvgPartnersDetails" />
                                    <div className='titleContainerPartnersDetailsWithSaldo'>
                                        <div className='txtTitleBoldAdsOfferPartnersDetails'>Associe um cartão bancário</div>
                                        <div className='txtPartnerInfoPartnersDetails'>
                                            <span className='txtPartnerInfoPartnersDetails'>Associe um ou mais cartões à Carteira Virtual através do MULTIBANCO ou da app MB Way.</span>
                                            <span className='txtPartnerContactDataPartnersDetails'><br/>Como associar um cartão?</span>
                                        </div>
                                    </div>
                                    {/* <div className='arrowBtnViewPartnerContactDataPartnersDetails'>
                                        <div className='txtArrowBtnPartnerContactDataPartnersDetails'>
                                            <img src={ImgArrowRight} alt='icon' className='iconBtnInfoNavBoxPartnersDetails' />
                                        </div>
                                    </div> */}
                                </div>
                                { isTablet ? (
                                    null
                                    ) : isMobile ? (
                                        <>
                                        <div className='boxMainShadowFirstViewContainerBottomViewContainerPartnersDetailsTablet'>
                                            <div className='boxShadowFirstViewContainerBottomViewContainerPartnersDetailsTablet'></div>
                                        </div>
                                        <div className='boxMainShadowFirstViewContainerBottomViewContainerPartnersDetailsTablet'>
                                            <div className='boxShadowSecondViewContainerBottomViewContainerPartnersDetailsTablet'></div>
                                        </div>
                                        </>
                                    ) : ( 
                                        null 
                                    )
                                }
                            </SwiperSlide>

                            <SwiperSlide>
                                <div onClick={hadleBtnBoxGoPartnersList} className={ isTablet ? 'boxViewContainerBottomViewContainerPartnersDetails' : ( isMobile ? 'boxViewContainerBottomViewContainerPartnersDetailsTablet' : 'boxViewContainerBottomViewContainerPartnersDetailsMobile')}>
                                    <img src={IconGetPercentage} alt="imagem" className="iconPartnerLogoSvgPartnersDetails" />
                                    <div className='titleContainerPartnersDetailsWithSaldo'>
                                        <div className='txtTitleBoldAdsOfferPartnersDetails'>Receba uma percentagem de cada compra</div>
                                        <div className='txtPartnerInfoPartnersDetails'>
                                            <span className='txtPartnerInfoPartnersDetails'>Depois de associado, basta fazer compras usando esse cartão na </span>
                                            <span className='txtPartnerContactDataPartnersDetails'>rede de parceiros </span>
                                            <span className='txtPartnerInfoPartnersDetails'>da Carteira Virtual.</span>
                                        </div>
                                    </div>
                                    {/* <div className='arrowBtnViewPartnerContactDataPartnersDetails'>
                                        <div className='txtArrowBtnPartnerContactDataPartnersDetails'>
                                            <img src={ImgArrowRight} alt='icon' className='iconBtnInfoNavBoxPartnersDetails' />
                                        </div>                                    
                                    </div> */}
                                </div>
                                { isTablet ? (
                                    null
                                    ) : isMobile ? (
                                        <>
                                        <div className='boxMainShadowFirstViewContainerBottomViewContainerPartnersDetailsTablet'>
                                            <div className='boxShadowFirstViewContainerBottomViewContainerPartnersDetailsTablet'></div>
                                        </div>
                                        <div className='boxMainShadowFirstViewContainerBottomViewContainerPartnersDetailsTablet'>
                                            <div className='boxShadowSecondViewContainerBottomViewContainerPartnersDetailsTablet'></div>
                                        </div>
                                        </>
                                    ) : ( 
                                        null 
                                    )
                                }
                            </SwiperSlide>

                            <SwiperSlide>
                                <div onClick={hadleBtnBoxGoMarketplace} className={ isTablet ? 'boxViewContainerBottomViewContainerPartnersDetails' : ( isMobile ? 'boxViewContainerBottomViewContainerPartnersDetailsTablet' : 'boxViewContainerBottomViewContainerPartnersDetailsMobile')}>
                                    <img src={IconSpendBalance} alt="imagem" className="iconPartnerLogoSvgPartnersDetails" />
                                    <div className='titleContainerPartnersDetailsWithSaldo'>
                                        <div className='txtTitleBoldAdsOfferPartnersDetails'>Gaste o saldo na sua saúde</div>
                                        <div className='txtPartnerInfoPartnersDetails'>
                                            <span className='txtPartnerInfoPartnersDetails'>Pode gastar o saldo em produtos ou serviços de saúde e bem-estar, à venda no </span>
                                            <span className='txtPartnerContactDataPartnersDetails'>Marketplace  Médis.</span>
                                        </div>
                                    </div>
                                    {/* <div className='arrowBtnViewPartnerContactDataPartnersDetails'>
                                        <div className='txtArrowBtnPartnerContactDataPartnersDetails'>
                                            <img src={ImgArrowRight} alt='icon' className='iconBtnInfoNavBoxPartnersDetails' />
                                        </div>                                    
                                    </div> */}
                                </div>
                                { isTablet ? (
                                    null
                                    ) : isMobile ? (
                                        <>
                                        <div className='boxMainShadowFirstViewContainerBottomViewContainerPartnersDetailsTablet'>
                                            <div className='boxShadowFirstViewContainerBottomViewContainerPartnersDetailsTablet'></div>
                                        </div>
                                        <div className='boxMainShadowFirstViewContainerBottomViewContainerPartnersDetailsTablet'>
                                            <div className='boxShadowSecondViewContainerBottomViewContainerPartnersDetailsTablet'></div>
                                        </div>
                                        </>
                                    ) : ( 
                                        null 
                                    )
                                }
                            </SwiperSlide>

                            <SwiperSlide>
                                <div onClick={hadleBtnBoxGoMovements} className={ isTablet ? 'boxViewContainerBottomViewContainerPartnersDetails' : ( isMobile ? 'boxViewContainerBottomViewContainerPartnersDetailsTablet' : 'boxViewContainerBottomViewContainerPartnersDetailsMobile')}>
                                    <img src={IconCheckHistory} alt="imagem" className="iconPartnerLogoSvgPartnersDetails" />
                                    <div className='titleContainerPartnersDetailsWithSaldo'>
                                        <div className='txtTitleBoldAdsOfferPartnersDetails'>Veja o seu histórico</div>
                                        <div className='txtPartnerInfoPartnersDetails'>
                                            <span className='txtPartnerInfoPartnersDetails'>Acompanhe quanto e onde acumulou saldo no </span>
                                            <span className='txtPartnerContactDataPartnersDetails'>histórico da Carteira Virtual.</span>
                                        </div>
                                    </div>
                                    {/* <div className='arrowBtnViewPartnerContactDataPartnersDetails'>
                                        <div className='txtArrowBtnPartnerContactDataPartnersDetails'>
                                            <img src={ImgArrowRight} alt='icon' className='iconBtnInfoNavBoxPartnersDetails' />
                                        </div>                                    
                                    </div> */}
                                </div>
                                { isTablet ? (
                                    null
                                    ) : isMobile ? (
                                        <>
                                        <div className='boxMainShadowFirstViewContainerBottomViewContainerPartnersDetailsTablet'>
                                            <div className='boxShadowFirstViewContainerBottomViewContainerPartnersDetailsTablet'></div>
                                        </div>
                                        <div className='boxMainShadowFirstViewContainerBottomViewContainerPartnersDetailsTablet'>
                                            <div className='boxShadowSecondViewContainerBottomViewContainerPartnersDetailsTablet'></div>
                                        </div>
                                        </>
                                    ) : ( 
                                        null 
                                    )
                                }
                            </SwiperSlide>
                        </Swiper>
                    </div>
                    <div className={isTablet ? 'thirdSubMainContainerCircleNavSeePartners' : 'thirdSubMainContainerSeePartnersMobile'}>
                        <button className='iconArrowLeftViewContainerCircleNavSeePartners' onClick={prevImageOne} disabled={swiperIndexOne == 0}>
                            <FaArrowLeftLong className='iconArrowCircleNavSeePartners' />
                        </button>

                        <div className='cirlceSelectedNavSeePartners'>
                            { isTablet ?
                                <div className='circleMainvViewNavSeePartners'>
                                    <div className='circleContainerNavSeePartners'>
                                        <div className={swiperIndexOne == 0 ? 'circleSelectedViewNavSeePartners' : 'circleViewNavSeePartners'} />
                                    </div>
                                    <div className='circleContainerNavSeePartners'>
                                        <div className={swiperIndexOne == 1 ? 'circleSelectedViewNavSeePartners' : 'circleViewNavSeePartners'} />
                                    </div>
                                </div>
                                :
                                <div className='circleMainvViewNavSeePartners'>
                                    <div className='circleContainerNavSeePartners'>
                                        <div className={swiperIndexOne == 0 ? 'circleSelectedViewNavSeePartners' : 'circleViewNavSeePartners'} />
                                    </div>
                                    <div className='circleContainerNavSeePartners'>
                                        <div className={swiperIndexOne == 1 ? 'circleSelectedViewNavSeePartners' : 'circleViewNavSeePartners'} />
                                    </div>
                                    <div className='circleContainerNavSeePartners'>
                                        <div className={swiperIndexOne == 2 ? 'circleSelectedViewNavSeePartners' : 'circleViewNavSeePartners'} />
                                    </div>
                                    <div className='circleContainerNavSeePartners'>
                                        <div className={swiperIndexOne >= 3 ? 'circleSelectedViewNavSeePartners' : 'circleViewNavSeePartners'} />
                                    </div>
                                </div>
                            }
                        </div>

                        <button className='iconArrowRightViewContainerCircleNavSeePartners' onClick={nextImageOne} disabled={ isTablet ? swiperIndexOne === 1 : swiperIndexOne >= 3}>
                            <FaArrowRightLong className='iconArrowCircleNavSeePartners' />
                        </button>
                    </div>
                </div>
                {/* End bottom div componet with info steps */}

            </div>
        </div>
        </>
        }
        <Footer/> 
        </>
    )
}

export default  PartnersDetails;